export const BOOKMARK_OPERATION_NAME = 'KnowledgeDiscoveryBookmark';
export const BookmarkQuery: "\n\tquery KnowledgeDiscoveryBookmark($cloudId: String!, $keyPhrase: String!) {\n\t\tknowledgeDiscovery {\n\t\t\tbookmark(cloudId: $cloudId, keyPhrase: $keyPhrase) {\n\t\t\t\t__typename\n\t\t\t\t... on KnowledgeDiscoveryBookmark {\n\t\t\t\t\tid\n\t\t\t\t\tproperties {\n\t\t\t\t\t\turl\n\t\t\t\t\t\ttitle\n\t\t\t\t\t\tdescription\n\t\t\t\t\t\tbookmarkState\n\t\t\t\t\t\tlastModifierAccountId\n\t\t\t\t\t\tkeyPhrase\n\t\t\t\t\t\tparentAdminhubBookmarkId\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t... on QueryError {\n\t\t\t\t\tidentifier\n\t\t\t\t\tmessage\n\t\t\t\t\textensions {\n\t\t\t\t\t\terrorType\n\t\t\t\t\t\tstatusCode\n\t\t\t\t\t\t... on GenericQueryErrorExtension {\n\t\t\t\t\t\t\terrorType\n\t\t\t\t\t\t\tstatusCode\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n" = `
	query ${BOOKMARK_OPERATION_NAME}($cloudId: String!, $keyPhrase: String!) {
		knowledgeDiscovery {
			bookmark(cloudId: $cloudId, keyPhrase: $keyPhrase) {
				__typename
				... on KnowledgeDiscoveryBookmark {
					id
					properties {
						url
						title
						description
						bookmarkState
						lastModifierAccountId
						keyPhrase
						parentAdminhubBookmarkId
					}
				}
				... on QueryError {
					identifier
					message
					extensions {
						errorType
						statusCode
						... on GenericQueryErrorExtension {
							errorType
							statusCode
						}
					}
				}
			}
		}
	}
`;
